package br.gov.go.pge.permanenciaweb.site.components

import br.gov.go.pge.permanenciaweb.site.IndustrialPalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.style.addVariant
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

/*
 * User-defined Silk `Button` variants, replacing the old `button.primary` / `button.danger` /
 * `button.link` classes. Call sites pass `ButtonSize.SM` (0.875rem font, 2rem tall) to keep the
 * Industrial Dense metrics.
 */

val PrimaryButtonVariant = ButtonStyle.addVariant {
    base {
        Modifier
            .setVariable(ButtonVars.BackgroundDefaultColor, IndustrialPalette.Steel)
            .setVariable(ButtonVars.BackgroundHoverColor, IndustrialPalette.Steel)
            .setVariable(ButtonVars.BackgroundPressedColor, IndustrialPalette.Steel)
            .setVariable(ButtonVars.Color, IndustrialPalette.White)
            .fontWeight(FontWeight.Normal)
            // 1px hairline borders stay in px per the units policy.
            .border(1.px, LineStyle.Solid, IndustrialPalette.Steel)
            .borderRadius(0.25.cssRem)
            .padding(leftRight = 0.625.cssRem)
    }
}

val DangerButtonVariant = ButtonStyle.addVariant {
    base {
        Modifier
            .setVariable(ButtonVars.BackgroundDefaultColor, IndustrialPalette.White)
            .setVariable(ButtonVars.BackgroundHoverColor, IndustrialPalette.RedTint)
            .setVariable(ButtonVars.BackgroundPressedColor, IndustrialPalette.RedTint)
            .setVariable(ButtonVars.Color, IndustrialPalette.Red)
            .fontWeight(FontWeight.Normal)
            .border(1.px, LineStyle.Solid, IndustrialPalette.RedTint)
            .borderRadius(0.25.cssRem)
            .padding(leftRight = 0.625.cssRem)
    }
}

/**
 * Extra variant beyond the plan's Primary/Danger/Link: the old UI's default control look (white,
 * 1px border) for "Cancelar" and the inactive tab, which would otherwise fall back to Silk's
 * gray default button.
 */
val DefaultButtonVariant = ButtonStyle.addVariant {
    base {
        Modifier
            .setVariable(ButtonVars.BackgroundDefaultColor, IndustrialPalette.White)
            .setVariable(ButtonVars.BackgroundHoverColor, IndustrialPalette.White)
            .setVariable(ButtonVars.BackgroundPressedColor, IndustrialPalette.White)
            .setVariable(ButtonVars.Color, IndustrialPalette.Ink)
            .fontWeight(FontWeight.Normal)
            .border(1.px, LineStyle.Solid, IndustrialPalette.Border)
            .borderRadius(0.25.cssRem)
            .padding(leftRight = 0.625.cssRem)
    }
}

val LinkButtonVariant = ButtonStyle.addVariant {
    base {
        Modifier
            .setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
            .setVariable(ButtonVars.BackgroundHoverColor, Colors.Transparent)
            .setVariable(ButtonVars.BackgroundPressedColor, Colors.Transparent)
            .setVariable(ButtonVars.Color, IndustrialPalette.Steel)
            .fontWeight(FontWeight.Normal)
            .border(0.cssRem)
            .height(autoLength)
            .minWidth(0.cssRem)
            .padding(0.cssRem)
            .textDecorationLine(TextDecorationLine.Underline)
    }
}
